import React, { useState, useEffect, createContext  } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import '../../../css/form.css';
import CreateLocation from "./create/createLocation";
import UpdateLocation from "./update/updateLocation";

const LocationContext = createContext();

function Location() {

  const [LocationList, setLocationList] = useState([]);
  const [ShowLocation, setShowLocation] = useState([]);
  const [LocationData, setLocationData] = useState([]);

  const [show, setShow] = useState(false);
  const [showUpdate, setShowUpdate] = useState(false);

  const handleCloseUpdate = () => setShowUpdate(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const Search = event => {
    const { value } = event.target;
    if(value){
      var results = [];
      results = LocationList.filter((data) => {
          return data.LocationName.toLowerCase().includes(value.toLowerCase())
      });
      if (results) 
        setShowLocation(results);
      else 
        setShowLocation(LocationList);
    } else 
      setShowLocation(LocationList);
  }

  const openUpdate = (LocationID, LocationName, Tell, Address) => {
    var list = [];
    list.push({
      LocationID: LocationID,
      LocationName: LocationName,
      Tell: Tell,
      Address: Address,
    });
    setLocationData(list);
    setShowUpdate(true);
  };
  
  useEffect(() => {
    let userData = localStorage.getItem("locationData");
    if (userData) {
      let userRole = JSON.parse(userData);
      setLocationList(userRole);
      setShowLocation(userRole);
    }
  }, []);

  return (
    <LocationContext.Provider value={{LocationList, setLocationList, LocationData, setLocationData}}>
      <div className="formContent">
        <CreateLocation show={show} onClick={handleClose}/>
        <UpdateLocation show={showUpdate} onClick={handleCloseUpdate}/>
        <div className="Header">
          <div className="title">
              <span>ຂໍ້ມູນ ສາຂາ</span>
          </div>
          <div className="txtSearch">
            <input placeholder="ຄົ້ນຫາ" onChange={(e) => Search(e)} />
            <button className="btn btn-primary" onClick={handleShow} >ເພີ່ມ</button>
          </div>
        </div>
        <div className="Body">
          <table className="styled-table">
            <thead>
              <tr key={1}>
                <th>ລ/ດ</th>
                <th>ສາຂາ</th>
                <th>ເບີໂທ</th>
                <th>ທີ່ຢູ່</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {
                ShowLocation && ShowLocation.map((x, y) => {
                    return (
                      <tr key={y}>
                        <td >{y + 1}</td>
                        <td >{x.LocationName}</td>
                        <td >{x.Tell}</td>
                        <td >{x.Address}</td>
                        <td >
                          <button className="btn btn-secondary" value={x.LocationID} type="button" onClick={() => openUpdate(x.LocationID, x.LocationName, x.Tell, x.Address)}>ແກ້ໄຂ</button>
                        </td>
                      </tr>
                    )
                })
              }
            </tbody>
          </table>
        </div>
      </div>
    </LocationContext.Provider>
  );
};

export {LocationContext};
export default Location;
